import Vue from 'vue'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import VModal from 'vue-js-modal'

Vue.use(Loading)
Vue.use(VModal)
